import { TType } from '../../hooks/useTranslation';
import * as Yup from 'yup';
import { investmentFields } from '../../utils/validation';
import { TransactionType } from '../../models/project';

export const returnFormatChangeValidationSchema = (t: TType, isep?: boolean) =>
  Yup.object().shape({
    unitCategory: Yup.string().required('Unit Category is required').nullable(),
    projectName: Yup.string()
      .required(t('validationMessages.projectNameIsRequired'))
      .nullable(),
    newUnitType: Yup.string()
      .required(t('validationMessages.unitTypeIsRequired'))
      .nullable(),
    businessUnitId: Yup.string()
      .required(t('validationMessages.businessUnitIsRequired'))
      .nullable(),
    unitType: Yup.string()
      .required(t('validationMessages.unitTypeIsRequired'))
      .nullable(),
    transactionType: Yup.string()
      .required(t('validation.transactionTypeRequired'))
      .nullable(),
    isLeasedFromAnotherIngkaCompany: Yup.string().when('transactionType', {
      is: TransactionType.LEASE,
      then: Yup.string().required(t('validation.leasedFromIngkaRequired')),
      otherwise: Yup.string().nullable().notRequired(),
    }),
    countryCode: Yup.string().required(t('validation.country')).nullable(),
    targetProjectStartDate: Yup.string()
      .required(t('validation.projectStartDate'))
      .nullable(),
    targetProjectEndDate: Yup.string()
      .required(t('validation.projectOpeningDate'))
      .nullable(),
    countryProjectResponsible: Yup.string()
      .required(t('validation.countryProjectResponsible'))
      .nullable(),
    stockedRangeAdjustment: Yup.string().nullable().notRequired(),
    storageCapacityAdjustment: Yup.string().nullable().notRequired(),
    truckFulfilmentCapacityAdjustment: Yup.string().nullable().notRequired(),
    parcelFulfilmentCapacityAdjustment: Yup.string().nullable().notRequired(),
    solutions: Yup.array().min(1).required(),
    automationLevel: Yup.string().nullable().notRequired(),
    ...investmentFields(t, isep),
    unifierId: Yup.string()
      .nullable()
      .matches(/^CMT\d{5}$/, {
        message: t('validationMessages.unifierIdWrongFormat'),
        excludeEmptyString: true,
      }),
  });
